export default __webpack_public_path__ + "static/media/add-patient.e9eb26fb.png";